'use client';

import { WoundLocationItem } from './libs/components/wound-location-item/wound-location-item';
import WoundLegIllustration from '../../../../../../../../../public/svg/find-professional/nav-legs-icon.svg';
import WoundFootIllustration from '../../../../../../../../../public/svg/find-professional/Nav_Foot_Icon.svg';
import WoundBodyIllustration from '../../../../../../../../../public/svg/find-professional/nav-body-icon.svg';
import WoundHeadIllustration from '../../../../../../../../../public/svg/find-professional/nav-head-icon.svg';
import { StepNumber } from '../step-number/step-number';
import { FormButton } from '../../../../../../../_libs/components/components';
import { useState } from 'react';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';
import { cn } from '@shared/shared-utils';

type Properties = {
  onWoundLocationClick: (woundLocation: string) => void;
};

const WoundLocationStep = ({ onWoundLocationClick }: Properties) => {
  const [selectedWoundLocations, setSelectedWoundLocations] = useState<
    string[]
  >([]);

  const handleWoundLocationClick = (woundLocation: string) => {
    setSelectedWoundLocations((current) => {
      const isSelected = current.includes(woundLocation);
      if (isSelected) {
        return current.filter((item) => item !== woundLocation);
      }
      return [...current, woundLocation];
    });
  };

  return (
    <div className="pb-[67px]">
      <div className="flex flex-col lg:flex-row justify-center lg:justify-start lg:ml-[50px] xl:ml-[150px] gap-x-6 items-center bg-white rounded-t-[16px] py-10">
        <div className="flex gap-x-4 lg:gap-x-6 items-center">
          <StepNumber number={1} />
          <h4 className="text-[30px] text-ogn-blue lg:text-[min(2.7vw,_44px)] font-bold leading-normal">
            Where is your wound located?
          </h4>
        </div>
        <h5 className="text-[16px] text-[#3D4543] font-bold">
          You can select more than one if appropriate.
        </h5>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-[repeat(auto-fit,_minmax(216px,_216px))] gap-y-8 gap-x-12 justify-center justify-items-center items-start">
        <WoundLocationItem
          woundIllustration={
            <WoundLegIllustration className={cn('w-[216px] h-[229px]')} />
          }
          caption="On the leg"
          onClick={() => handleWoundLocationClick('leg')}
          isSelected={selectedWoundLocations.includes('leg')}
        />
        <WoundLocationItem
          woundIllustration={
            <WoundFootIllustration className="w-[218px] h-[223px]" />
          }
          caption="On my foot"
          onClick={() => handleWoundLocationClick('foot')}
          isSelected={selectedWoundLocations.includes('foot')}
        />
        <WoundLocationItem
          woundIllustration={
            <WoundHeadIllustration className="w-[216px] h-[224px]" />
          }
          caption="On my head"
          onClick={() => handleWoundLocationClick('head')}
          isSelected={selectedWoundLocations.includes('head')}
        />
        <WoundLocationItem
          woundIllustration={
            <WoundBodyIllustration className="w-[216px] h-[218px]" />
          }
          caption="On another part of my body"
          onClick={() => handleWoundLocationClick('body')}
          isSelected={selectedWoundLocations.includes('body')}
        />
      </div>
      <FormButton
        className="mx-auto w-[300px] mt-16 font-roboto-condensed"
        onClick={() => onWoundLocationClick('')}
        isDisabled={selectedWoundLocations.length === 0}
      >
        Next
        <ArrowRightIcon className="w-6 h-6" />
      </FormButton>
    </div>
  );
};

export { WoundLocationStep };
